//@flow

/**
 * documentation of setting and getting cookies can be found here
 * https://www.w3schools.com/Js/js_cookies.asp
 */

export default class cookies {
  setCookie(
    cookieName: string,
    cookieValue: string | null,
    exdays: number | null,
    exInMs: number
  ) {
    // get the present date
    const d = new Date();
    const timeInMs = exdays ? exdays * 24 * 60 * 60 * 1000 : exInMs;
    //set the expiry date converting the given day from argument in ms
    d.setTime(d.getTime() + timeInMs);

    const expires = 'expires=' + d.toUTCString();

    //set the cookie with the given values

    if (typeof window !== 'undefined') {
      document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
    }
  }

  getCookie(cookieName: string) {
    // Take the cookiename as parameter (cname).
    // Create a variable (name) with the text to search for (cname + "=").
    const name = cookieName + '=';

    // Decode the cookie string, to handle cookies with special characters, e.g. '$'
    // Split document.cookie on semicolons into an array called c.
    if (typeof window !== 'undefined') {
      const ca = document.cookie.split(';');

      // Loop through the ca array (i = 0; i < ca.length; i++)
      //check necessary for server side rendering

      for (let i = 0; i < ca.length; i++) {
        // read out each value c = ca[i]).
        let c = ca[i];

        // eslint-disable-next-line
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        // eslint-disable-next-line
        const isCookieFound = c.indexOf(name) == 0;
        if (isCookieFound) return c.substring(name.length, c.length);
      }
    }
  }

  // in order to delete a cookie set the expires date to something in the past.
  deleteCookie(cookieName: string) {
    const d = new Date();
    d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
    const expires = `expires=${d.toGMTString()}`;

    if (typeof document !== 'undefined') {
      document.cookie = `${cookieName}=; ${expires};`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/cookies.js